/**
 * P9-P2D — Bidi isolation for LTR data inside (potentially) RTL text.
 *
 * Wraps inherently left-to-right data — VINs, phone numbers, URLs, emails, part
 * numbers, plate numbers — so it renders correctly even when the surrounding
 * paragraph is Arabic/RTL. Uses `dir="ltr"` + `unicode-bidi: isolate` so the
 * neutral characters (slashes, dots, dashes) don't get reordered.
 *
 * BEHAVIOUR-NEUTRAL in LTR: an isolated LTR run inside LTR text is identical.
 */
import React from 'react';

export function Ltr({ as: Tag = 'span', className = '', children, ...props }) {
  return (
    <Tag dir="ltr" style={{ unicodeBidi: 'isolate' }} className={className} {...props}>
      {children}
    </Tag>
  );
}

export default Ltr;
